module.exports = __webpack_public_path__ + "static/media/galerija_2017 (26).7d5b9acb.jpg";